export default __webpack_public_path__ + "static/media/mtn.b475bf4b.jpg";